'use strict';

require('./Carousel.scss');

const React = require('react'),
    CarouselItem = require('./CarouselItem/CarouselItem'),
    { map, find } = require('lodash/collection'),
    {delay} = require('lodash/function'),
    get = require('lodash/object').get,
    { PropTypes } = require('react');

const INTERVAL_TIME = 1000 * 32; // 32 seg

const Carousel = React.createClass({displayName: "Carousel",
    /**
     * interval of carousel component.
     */
    interval: null,

    propTypes: {
        items: PropTypes.string,
        onClick: PropTypes.func,
        onClickArrow: PropTypes.func
    },

    getInitialState() {
        return {
            prevIndex: 0,
            currentIndex: 1,
            nextIndex: 2,
            isBannerMoving: false
        };
    },

    componentDidMount() {
        this.interval = setInterval(() => {
            this.onClickArrow('RIGHT');
        }, INTERVAL_TIME);
    },

    componentWillUnmount() {
        clearInterval(this.interval);
    },

    onClickArrowLeft() {
        this.onClickArrow('LEFT');
    },

    onClickArrowRight() {
        this.onClickArrow('RIGHT');
    },

    onClickArrow(direction) {
        const { items, onClickArrow } = this.props;
        const haveItemsSeveralItems = items && items.length > 1;

        if (!haveItemsSeveralItems) {
            return;
        }

        const isLeftDirection = direction === 'LEFT';
        const isRightDirection = direction === 'RIGHT';

        this.setState(
            {
                isLeftDirection,
                isRightDirection,
                isBannerMoving: true
            },
            () => {
                delay(() => {
                    this.onBannerMoveEnd(direction);
                    if (onClickArrow) {
                        onClickArrow();
                    }
                }, 1001); // keep sync with $carousel-transition
            }
        );
    },

    onBannerMoveEnd(direction) {
        this.setState(prevState => {
            const lastUpdateItems = prevState.itemsUpdated || this.props.items;
            const itemsUpdated = _translateItemPositions(
                lastUpdateItems,
                direction
            );
            return { itemsUpdated, isBannerMoving: false };
        });
    },

    render() {
        const { items, onClick } = this.props;
        const { isLeftDirection, itemsUpdated, isBannerMoving } = this.state;
        const lastUpdateItems = itemsUpdated || items;

        const prevItem = find(lastUpdateItems, item => item.index === 0);
        const currentItem = find(lastUpdateItems, item => item.index === 1);
        const nextItem = find(lastUpdateItems, item => item.index === 2);

        const filteredItems = [prevItem, currentItem, nextItem];

        const currentItemsEl = map(filteredItems, filterItem => {
            let className;

            if (isBannerMoving) {
                className = _buildClassName(filterItem, isLeftDirection);
            }

            return (
                React.createElement(CarouselItem, {
                    onClick: onClick.bind(this, filterItem), 
                    imageSrc: filterItem.imgSrc, 
                    imageStyle: filterItem.imgStyle || {}, 
                    name: filterItem.name, 
                    link: filterItem.link, 
                    linkHoverName: filterItem.name, 
                    className: className}
                )
            );
        });

        return (
            React.createElement("div", {className: "bp-carousel"}, 
                React.createElement("div", {
                    onClick: isBannerMoving ? null : this.onClickArrowLeft, 
                    className: "bp-carousel__arrow bp-carousel__arrow-left"
                }, 
                    React.createElement("i", {className: "material-icons"}, "keyboard_arrow_left")
                ), 
                React.createElement("ul", {className: "bp-carousel__content"}, 
                    currentItemsEl
                ), 
                React.createElement("div", {
                    onClick: isBannerMoving ? null : this.onClickArrowRight, 
                    className: "bp-carousel__arrow bp-carousel__arrow-right"
                }, 
                    React.createElement("i", {className: "material-icons"}, "keyboard_arrow_right")
                )
            )
        );
    }
});

function _buildClassName(item, isLeftDirection) {
    let className = '';
    const isCenterBanner = item.index === 1;
    const isLeftBanner = item.index === 0;
    const isRightBanner = item.index === 2;
    const isRightDirection = isLeftDirection === false;

    if (isRightDirection) {
        if (isRightBanner) {
            className += 'pull-left-banner';
        } else if (isCenterBanner) {
            className += 'pull-left-banner';
        }
    } else {
        if (isLeftBanner) {
            className += 'pull-right-banner';
        } else if (isCenterBanner) {
            className += 'pull-right-banner';
        }
    }

    className += ' is-moving';

    return className;
}

function _updateItemIndex(item, direction, amountItems) {
    const currentIndex = get(item, 'index');
    let nextIndex = currentIndex;
    const firstIndexPosition = 0;
    const isLeftDirection = direction === 'LEFT';
    const isRightDirection = direction === 'RIGHT';
    const isFirstPosition = currentIndex === firstIndexPosition;
    const isLastPosition = currentIndex === amountItems;

    if (isFirstPosition && isLeftDirection) {
        nextIndex++;
    } else if (isFirstPosition && isRightDirection) {
        nextIndex = amountItems;
    } else if (isLastPosition && isLeftDirection) {
        nextIndex = firstIndexPosition;
    } else if (isLastPosition && isRightDirection) {
        nextIndex--;
    } else if (isLeftDirection) {
        nextIndex++;
    } else if (isRightDirection) {
        nextIndex--;
    }

    item.index = nextIndex;

    return item;
}

function _translateItemPositions(items, direction) {
    const amountItems = get(items, 'length', 1);
    return map(items, item => {
        return _updateItemIndex(item, direction, amountItems - 1);
    });
}

module.exports = Carousel;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/Carousel/Carousel.jsx
 **/